import { useState } from 'react';
import Loader from './app/elements/loader';
import RootLayout from './layouts/root-layout';
import ScrollToTop from './app/elements/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';

export default function App() {
	const [isLoading, setIsLoading] = useState(true);

	setTimeout(() => {
		setIsLoading(false);
	}, 500);

	return (
		<>
			<HelmetProvider>
				{isLoading && <Loader />}
				<ToastContainer position='top-center' />
				<ScrollToTop />
				<RootLayout />
			</HelmetProvider>
		</>
	);
}
